import type { DrawingProps } from "./types";

/** Used once a page is done, and never to rank a child. */
export function Star({ size = 32, className, title }: DrawingProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      <path
        d="M16 4.5c1.1 4.6 2.9 6.4 7.5 7.5-4.6 1.1-6.4 2.9-7.5 7.5-1.1-4.6-2.9-6.4-7.5-7.5 4.6-1.1 6.4-2.9 7.5-7.5Z"
        fill="var(--marigold)"
        stroke="var(--ink)"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <path
        d="M24.5 20c.6 2.4 1.5 3.3 3.9 3.9-2.4.6-3.3 1.5-3.9 3.9-.6-2.4-1.5-3.3-3.9-3.9 2.4-.6 3.3-1.5 3.9-3.9Z"
        fill="var(--sage)"
        stroke="var(--ink)"
        strokeWidth="2.2"
        strokeLinejoin="round"
      />
    </svg>
  );
}
